import React, { useState } from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import { landlord_property_type, preferredTenantOptions, propertyAvailabilityStatus, setStatusColor } from "../../Config";
import { getFoodPreferenceLabel, getFurnishedLabel } from "../../helpers";

const ViewDetailModel = ({ setViewDetail, selectedData }) => {
  const [detailType, setDetailType] = useState("1");

  const getStatus = (status) => {
    const statusObj = propertyAvailabilityStatus.find(
      (item) => item.value === status,
    );

    const label = statusObj?.label || "Nothing";

    return (
      <div
        className={`text-xs border w-24 h-7 flex items-center justify-center rounded-full ${setStatusColor(label)}`}
      >
        {label}
      </div>
    );
  };


  const getId = (id) => {
    if (id) {
      return <PropertyId>#{id}</PropertyId>;
    } else {
      return <Unverified>N/A</Unverified>;
    }
  };

  const getRent = (isRentAgreementEnabled) => {
    if (isRentAgreementEnabled === 1) {
      return <p>Yes</p>;
    } else {
      return <p>No</p>;
    }
  };

  const getInventoryType = (inventoryType) => {
    const inventoryTypeObj = landlord_property_type.find(
      (type) => type.value === inventoryType
    );

    const inventoryLabel = inventoryTypeObj?.label || "N/A";

    return (
      <div>
        <span>{inventoryLabel}</span>
      </div>
    );
  };

  const getTenantPreference = (tenantPreference) => {
    const tenantpref = preferredTenantOptions.find(
      (type) => type.value === tenantPreference
    );
    const tenantLabel = tenantpref?.label || "N/A";
    return(
      <div>
        <span>
          {tenantLabel}
        </span>
      </div>
    )
  };

  return (
    <Model width={`w-11/12 max-w-lg `} setOpenModel={setViewDetail}>
      <Wrapper>
        <Title>View Details</Title>
        <div className="flex my-4">
          {/* <Status className="m-2">
            {getProperty(selectedData?.gId) || "N/A"}
            </Status> */}
          <Status>{getId(selectedData?.id) || "N/A"}</Status>
          <Status className="ml-3">
            {getStatus(selectedData?.status) || "N/A"}
          </Status>
        </div>
        {/* 
        <SubHeading>Name</SubHeading>
        <Paragraph>{selectedData?.name || "N/A"}</Paragraph> */}
        <Column>
          <FirstColumn>
            <SubHeading>Inventory Name</SubHeading>
            <Paragraph>{selectedData?.inventoryName || "N/A"}</Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Flat/House No</SubHeading>
            <Paragraph>{selectedData?.flatNo || "N/A"}</Paragraph>
          </SecondColumn>
        </Column>

        <Column>
          <FirstColumn>
            <SubHeading>Created At</SubHeading>
            <Paragraph>
              {moment(selectedData?.createdAt).format("LL") || "N/A"}
            </Paragraph>
          </FirstColumn>
          <SecondColumn>
            <SubHeading>Updated At</SubHeading>
            <Paragraph>
              {moment(selectedData?.updatedAt).format("LL") || "N/A"}
            </Paragraph>
          </SecondColumn>
        </Column>

        <ButtonGroup>
          <TemplateButton
            isActive={detailType === "1"}
            onClick={() => setDetailType("1")}
          >
            Basic Details
          </TemplateButton>
          <TemplateButton
            ml
            isActive={detailType === "2"}
            onClick={() => setDetailType("2")}
          >
            Agreement Details
          </TemplateButton>
          <TemplateButton
            ml
            isActive={detailType === "3"}
            onClick={() => setDetailType("3")}
          >
            Rent Details
          </TemplateButton>
        </ButtonGroup>
        <Seperator />

        <div className="h-[37vh] overflow-y-auto">
          {detailType === "1" && (
            <>
              <SingleItem
                name={"Belongs To Name"}
                value={selectedData?.belongsToName || "N/A"}
              />
              <SingleItem
                name={"Mobile Number"}
                value={selectedData?.belongsToMobile || "N/A"}
              />
              <SingleItem
                name={"Address"}
                value={selectedData?.address || "N/A"}
              />
              <SingleItem
                name={"Inventory Type"}
                value={getInventoryType(selectedData?.inventoryType || "N/A")}
              />
              <SingleItem
                name={"Tenant Preference"}
                value={getTenantPreference(selectedData?.tenantPreference || "N/A")}
              />
              <SingleItem
                name={"Food Preference"}
                value={getFoodPreferenceLabel(selectedData?.tenantPreference || "N/A")}
              />
              <SingleItem
                name={"Interior Type"}
                value={getFurnishedLabel(selectedData?.tenantPreference || "N/A")}
              />
            </>
          )}

          {detailType === "2" && (
            <>
              <SingleItem
                name="Agreement Period"
                value={selectedData?.agreementPeriod || "N/A"}
              />
              <SingleItem
                name="Notice Period"
                value={selectedData?.noticePeriod || "N/A"}
              />
              <SingleItem
                name="Lock-In Period"
                value={selectedData?.lockInPeriod || "N/A"}
              />
            </>
          )}

          {detailType === "3" && (
            <>
              <SingleItem
                name="Rent"
                value={selectedData?.amount || "N/A"}
              />
              <SingleItem
                name="Security"
                value={selectedData?.deposit || "N/A"}
              />
              <SingleItem
                name="Maintenance"
                value={selectedData?.maintenance || "N/A"}
              />
              <SingleItem
                name="Rental Cycle"
                value={selectedData?.rentalCycle || "N/A"}
              />
              <SingleItem
                name="Rent Agreement"
                value={getRent(selectedData?.isRentAgreementEnabled || "N/A")}
              />
            </>
          )}
        </div>
      </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value }) => (
  <div className="flex items-center py-1.5 border-b border-gray-100">
    <Name>{name}</Name> <span>:</span>
    <Value>
      {(name === "Security" || name === "Rent" || name === "Maintenance") &&
        value !== "N/A" && <span className="mr-1">₹</span>}
      {value}
      {(name === "Agreement Period" ||
        name === "Notice Period" ||
        name === "Lock-In Period") && <span className="ml-1">months</span>}
      {name === "Grace Period" && <span className="ml-1">days</span>}
    </Value>
  </div>
);

const TemplateButton = ({ isActive, ml, ...rest }) => {
  return (
    <button
      className={`pl-0 pr-2 font-medium text-sm relative ${
        isActive ? "text-blue-500" : "text-gray-400"
      } ${
        ml ? "ml-4" : ""
      } after:absolute after:top-7 after:left-0 after:w-full after:h-0.5 ${
        isActive ? "after:bg-blue-500" : ""
      }`}
      {...rest}
    >
      {rest.children}
    </button>
  );
};

const ButtonGroup = tw.div`flex items-center !gap-0 mt-6 `;
const Seperator = tw.div`w-full h-[0.07rem] bg-gray-200 my-2 `;
const Status = tw.div``;
const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const Name = tw.span`text-sm text-gray-500  w-32`;
const Value = tw.span`text-sm text-black font-medium w-80 px-6 `;
const PropertyId = tw.div`bg-cyan-600 text-white text-xs  inline-block py-1 max-w-fit px-3 flex items-center justify-center rounded-full`;
const Column = tw.div`grid grid-cols-2 my-3 gap-2`;
const FirstColumn = tw.div``;
const SecondColumn = tw.div``;
const SubHeading = tw.h2`text-xs text-blue-500 font-[600] mb-1`;
const Paragraph = tw.p`text-sm text-gray-900 font-semibold`;
const Unverified = tw.div`border border-rose-600 text-rose-600 text-xs  inline-block py-1 max-w-fit px-4 flex items-center justify-center rounded-full`;
export default ViewDetailModel;
